import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Color } from "../../../../Utils/styles";
import StepForm from "../../../Common/Components/StepForm";
import { useState } from "react";
const Contract = ({ isApp }) => {
  const { user: { item }, } = useSelector(state => state);

  const [showSpecific, setShowSpecific] = useState(false)

  const renderContractSteps = () => {
    if (
      item &&
      item[0].timetable_option &&
      item[0].timetable_option.needghest == "true"
    ) {
      return {
        route: "/contractreserve/create",
        titr: "ثبت قرداد",
        firstStep: "step_1",
        lastStep: "step_5",
        lastBtn: "ثبت قرارداد",
        initialeState: { times: [] },
        filterData: data => {
          return { ...data, ...data.result };
        },
        steps: [
          "تاریخ شروع و پایان قرارداد",
          "انتخاب کاربر",
          "انتخاب سانس ها",
          "ثبت قرارداد",
          "انتخاب نحوه پرداخت",
        ],
        step_1: {
          validate: {
            route: "/contractreserve/checkdate",
          },
          form: [
            {
              name: "تاریخ شروع",
              key: "date_start",
              type: "date",
              col: "col-md-6",
            },
            {
              name: "تاریخ پایان",
              key: "date_end",
              type: "date",
              col: "col-md-6",
            },
          ],
        },
        step_2: {
          method: () => { },
          form: [
            {
              type: "selectUser",
              noNeed: true,
            },
          ],
        },
        step_3: {
          key: "times",
          validate: {
            route: "/contractreserve/check_create",
            key: "acsses",
          },
          form: [
            {
              noNeed: true,
              type: "selectSans",
            },
          ],
        },
        step_4: {
          form: [
            {
              noNeed: true,

              type: "confirm",
            },
          ],
        },
        step_5: {
          form: [
            {
              type: "customComponent",
              noNeed: true,
              render: (form, setForm) => {

                return (
                  <div className="col-12">
                    <div className="row justify-content-center mb-4">
                      <div className="col-md-6">
                        <h6
                          className="text-center"
                          style={{ fontSize: "20px", margin: 0 }}
                        >
                          مدیر مجموعه عزیز
                        </h6>
                        <p
                          className="text-center"
                          style={{
                            fontSize: "15px",
                            margin: "0",
                            fontWeight: "400",
                          }}
                        >
                          لطفا نحوه پرداخت را انتخاب کنید
                        </p>
                      </div>
                    </div>{" "}
                    <div className="row justify-content-center">
                      <div className={" d-flex justify-content-center " + (isApp ? "col-6" : "col-3")}>
                        <button
                          className={`btn ${form.show ? "btn-outline-primary " : "btn-primary "
                            } ${isApp && "nfs-12 w-100"}`}
                          onClick={() => {
                            setForm({ ...form, show: false });
                          }}
                          style={{
                            color: !form.show ? "#fff" : Color.black,
                          }}
                        >
                          پرداخت در محل
                        </button>
                      </div>
                      <div className={"d-flex justify-content-center " + (isApp ? "col-6" : "col-3")}>
                        <button
                          className={`btn ${!form.show ? "btn-outline-primary " : "btn-primary "
                            }${isApp && "nfs-12 w-100"}`}
                          style={{
                            color: form.show ? "#fff" : Color.black,
                          }}
                          onClick={() => {
                            setForm({ ...form, needghest: true, show: true });
                          }}
                        >
                          پرداخت در نیکوتن
                        </button>
                      </div>
                    </div>
                    {form.show && (
                      <>
                        <div className="row justify-content-center mt-4">
                          <div className={"d-flex justify-content-center " + (isApp ? "col-12" : "col-6")}>
                            <select
                              className="form-select form-control"
                              aria-label="Default select example"
                              onChange={({ target: { value } }) => {
                                setForm({ ...form, ghest: value });
                              }}
                            >
                              <option selected>
                                لطفا بازه پرداخت را انتخاب کنید
                              </option>
                              <option value={1}>
                                باز پرداخت به صورت ماهیانه (هر یک ماه)
                              </option>
                              <option value={3}>
                                باز پرداخت به صورت سه ماهه
                              </option>
                              <option value={6}>
                                باز پرداخت به صورت شش ماهه
                              </option>
                              <option value={12}>
                                باز پرداخت به صورت سالانه (هر یک سال)
                              </option>
                            </select>
                          </div>

                          <div className={"d-flex justify-content-center " + (isApp ? "col-12 mt-3" : "col-6")}>
                            <select
                              className="form-select form-control"
                              aria-label="Default select example"
                              onChange={({ target: { value } }) => {
                                if (value == "specific_date_pre" || value == "specific_date") {
                                  setForm({ ...form, pay_date_type: value });
                                  setShowSpecific(true)
                                }
                                else {
                                  setForm({ ...form, pay_date_type: value, pay_date: null });
                                  setShowSpecific(false)
                                }
                              }} >
                              <option selected>
                                لطفا زمان پرداخت را انتخاب کنید
                              </option>
                              <option value={"start_to_end_month"}>
                                دو روز قبل از اولین سانس
                              </option>
                              <option value={"next_date_first_time"}>
                                یک روز بعد از اولین سانس
                              </option>
                              <option value={'specific_date'}>
                                روز مشخص ماه جاری
                              </option>
                              <option value={'specific_date_pre'}>
                                روز مشخص ماه قبل
                              </option>
                            </select>
                          </div>

                          {showSpecific && (
                            <div className={"d-flex justify-content-center mt-3 " + (isApp ? "col-12" : "col-6")}>
                              <select
                                className="form-select form-control"
                                aria-label="Default select example"
                                onChange={({ target: { value } }) => {
                                  setForm({ ...form, pay_date: value });
                                }} >
                                <option selected>
                                  لطفا روز پرداخت را انتخاب کنید
                                </option>
                                {Array.from(Array(31), (e, i) => {
                                  return <option value={i + 1}> {i + 1} </option>
                                })}
                              </select>
                            </div>
                          )}
                        </div>
                      </>
                    )
                    }
                  </div >
                );
              },
            },
          ],
        },
      };
    } else {
      return {
        route: "/contractreserve/create",
        titr: "ثبت قرداد",
        firstStep: "step_1",
        lastStep: "step_4",
        lastBtn: "ثبت قرارداد",
        initialeState: { times: [] },
        filterData: data => {
          return { ...data, ...data.result };
        },
        steps: [
          "تاریخ شروع و پایان قرارداد",
          "انتخاب کاربر",
          "انتخاب سانس ها",
          "ثبت قرارداد",
        ],
        step_1: {
          validate: {
            route: "/contractreserve/checkdate",
          },
          form: [
            {
              name: "تاریخ شروع",
              key: "date_start",
              type: "date",
              col: "col-md-6",
            },
            {
              name: "تاریخ پایان",
              key: "date_end",
              type: "date",
              col: "col-md-6",
            },
          ],
        },
        step_2: {
          method: () => { },
          form: [
            {
              type: "selectUser",
              noNeed: true,
            },
          ],
        },
        step_3: {
          key: "times",
          validate: {
            route: "/contractreserve/check_create",
            key: "acsses",
          },
          form: [
            {
              noNeed: true,
              type: "selectSans",
            },
          ],
        },
        step_4: {
          form: [
            {
              type: "confirm",
            },
          ],
        },
      };
    }
  };
  const form = {};
  return <StepForm isApp={isApp} elements={renderContractSteps()} />;
};

export default Contract;
